"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createTrackingService = exports.createAndBootstrapTrackingService = void 0;
const oneaudi_os_onesight_1 = require("@volkswagen-onehub/oneaudi-os-onesight");
const tracking_adapter_1 = require("./tracking-adapter");
/**
 * Method to create and fully bootstrap a oneAudiOS compatible TrackingService.
 * After calling this, you can directly start with tracking.
 *
 * @param options Configuration
 *
 *
 * Example:
 * ```
 * const trackingService = createAndBootstrapTrackingService({
 *     appId: 'oneaudi-myapp-id',
 *     appName: __FEATURE_APP_NAME__,
 *     appVersion: __FEATURE_APP_VERSION__
 * });
 * trackingService.track({ ... });
 * ```
 */
function createAndBootstrapTrackingService(options) {
    const adapter = createTrackingService(options.appId, options.init?.datalayer, options.init?.urlSanitizer, options.init?.logger);
    adapter.featureAppName = options.appName;
    adapter.updateComponent({
        componentInfo: {
            // componentID is needed, but defined as "never"
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            componentID: options.appId,
        },
        attributes: {
            implementer: options.implementer ?? oneaudi_os_onesight_1.Implementer.UNKNOWN,
            version: options.appVersion,
            absoluteNumber: options.absoluteNumber ?? 1,
            instanceNumber: options.instanceNumber ?? 1,
        },
    });
    return adapter;
}
exports.createAndBootstrapTrackingService = createAndBootstrapTrackingService;
/**
 * Method to create a oneAudiOS compatible TrackingService.
 *
 * Make sure to set `featureAppName` afterwards.
 * Certain methods will throw an error if the feature app's name is not defined. Setting
 * `trackingService.featureAppName` ensures the existence of the component.
 *
 * @param appId Mandatory: id of the feature app which wants to use tracking
 * @param datalayer Optional: The datalayer instance. If absent, a new instance will be created.
 * Existing `window.digitalData` will be reused
 * @param urlSanitizer Optional: The sanitizer to be used for URLs. If absent, a default will be
 *  used which strips away personal information.
 * @param logger Optional: The Logger. If absent, the console will be used for logging
 *
 * Example:
 * ```
 * const trackingService = createTrackingService('app-id');
 * trackingService.featureAppName = 'my-feature-app';
 * trackingService.track({ ... });
 * ```
 */
function createTrackingService(appId, datalayer, urlSanitizer, logger) {
    return new tracking_adapter_1.TrackingAdapter(appId, datalayer, urlSanitizer, logger);
}
exports.createTrackingService = createTrackingService;
